import Button from "@elements/button";
import { useTranslations } from "next-intl";
import { useMemo, useState } from "react";
import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();

const OpenInAppBanner: React.FC = () => {
  const t = useTranslations("");
  const [closed, setClosed] = useState(false);
  const mobileAppURL = useMemo(() => {
    if (/iPhone|iPad|iPod/i.test(navigator?.userAgent)) return publicRuntimeConfig.IOS_APP_URL;
    if (/Android/i.test(navigator?.userAgent)) return publicRuntimeConfig.ANDROID_APP_URL;
  }, []);
  const handleOpenApp = () => {
    if (mobileAppURL) {
      // Extract pathname from current URL
      const url = new URL(window.location.href);
      let pathname = url.pathname;
      if (pathname.includes('wishlist')) {
        // Extract pathname from current URL

        // Remove locale from pathname
        const pathSegments = pathname.split('/').filter(segment => segment.length > 0);
        pathSegments.shift();

        // Reconstruct pathname without locale
        const cleanPathname = pathSegments.length > 0 ? '/' + pathSegments.join('/') : '';

        // Create deeplink: dabdoobapp://open + pathname with first letter capitalized
        const capitalizedPathname = cleanPathname.charAt(1).toUpperCase() + cleanPathname.slice(2);
        const deeplink = `dabdoobapp://open${capitalizedPathname}`;


        console.log("🚀🚀🚀 ~ open-in-app-banner.tsx:34 ~ handleOpenApp ~ deeplink:", deeplink)

        window.location.href = deeplink;
      } else {
        const deeplink=  window.location.href.replace(/https?:\/\//g, "dabdoobapp://");

        console.log("🚀🚀🚀 ~ open-in-app-banner.tsx:40 ~ handleOpenApp ~ deeplink:", deeplink)

        window.location.href = deeplink
      }
      // setTimeout still executes after the app is opened, so the current page will navigate to the fallback link
      // to prevent this, I use the document.hasFocus function to check
      setTimeout(function () {
        // if the app is opened, the document won't be focused
        // so if app is not installed, the document will be focused
        if (document.hasFocus()) {
          // window.location = mobileAppURL;
        }
      }, 1000);
    }
  };
  return !mobileAppURL || closed ? null : (
    <div className=" max-w-[1240px] mx-auto w-full flex items-center md:px-5 px-3 py-3 justify-between h-16">
      <div className="flex items-center gap-3">
        <Button
          className="!min-w-min w-8 h-8 px-1 py-1 text-xl justify-center -mt-1 text-gray-400 bg-gray-100 rounded-full"
          size="mini"
          theme="light"
          onClick={() => setClosed(true)}
        >
          ×
        </Button>
        <p className=" font-bold text-sm flex-1 sm:mb-0 mb-2 text-[#333] sm:text-left text-center leading-7">
          {t("Open In App")}
        </p>
      </div>
      <Button
        className="mx-5 px-2 rounded-lg font-bold text-sm md:scale-125"
        size="mini"
        onClick={handleOpenApp}
      >
        {t("Open")}
      </Button>
    </div>
  );
};

export default OpenInAppBanner;
